import React, { Component } from "react";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  Button
} from "@material-ui/core/";

import { xencallService } from "../services";
import { ManageClient } from "./ManageClient";

const floatLeft = {
  float: "left",
  margin: "5px"
};

class MigrateClient extends Component {
  constructor(props) {
    super(props);
    this.state = {
      migrated: false,
      stage: 0
    };
    this.migrateClient = this.migrateClient.bind(this);
  }

  componentDidMount() {}

  migrateClient() {
    console.log("migrateClient()", this.props);
    const { client } = this.props;
    this.setState({ stage: 1 });
    xencallService.migrateClient(this, client.id);
  }

  render() {
    const { client, cancel, refresh } = this.props;
    const { stage } = this.state;

    console.log("MigrateClient", this.props, this.state);

    return (
      <div>
        {stage < 2 && (
          <div style={{ padding: 16, margin: "auto" }}>
            <Typography
              component="h2"
              variant="h6"
              color="primary"
              gutterBottom
              style={{ textAlign: "center" }}
            >
              Migrate Client
            </Typography>
            <List>
              <ListItem>
                <ListItemText
                  disableTypography
                  primary={
                    <Typography
                      type="body2"
                      style={{ fontSize: 20, fontWeight: 600 }}
                    >
                      {client.name}
                    </Typography>
                  }
                  secondary={
                    <Typography type="body2" style={{ fontSize: 16 }}>
                      {"Client Id " + client.id}
                    </Typography>
                  }
                />
              </ListItem>
            </List>
          </div>
        )}
        {stage === 0 && (
          <div>
            <Button variant="contained" onClick={cancel} style={floatLeft}>
              Cancel
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={this.migrateClient}
              style={floatLeft}
            >
              Migrate
            </Button>
          </div>
        )}
        {stage === 2 && (
          <div>
            <ManageClient client={client} cancel={cancel} refresh={refresh} />
          </div>
        )}
      </div>
    );
  }
}

export { MigrateClient };
